module.exports = __webpack_public_path__ + "img/1555702378.564f8c9b.jpg";